/**
 * User flows and custom policies for B2C application
 */

function getTenantName() {
    switch (process.env.VUE_APP_API_ENV) {
        case 'testapi':
        case 'dev':
        case 'local':
        case 'localtunnel':
            return 'logintest';
        // case 'example':
        //     return 'apiexample';
        default:
            return 'login';
    }
}

function getScopeSubdomain() {
    switch (process.env.VUE_APP_API_ENV) {
        case 'testapi':
        case 'dev':
        case 'local':
        case 'localtunnel':
            return 'apitest';
        // case 'example':
        //     return 'apiexample';
        default:
            return 'efundapi';
    }
}

function getClientId() {
    switch (process.env.VUE_APP_API_ENV) {
        case 'testapi':
        case 'dev':
        case 'local':
        case 'localtunnel':
            return '73ecdab7-b592-4a27-8b17-47f71b07275a';
        // case 'example':
        //     return 'apiexample';
        default:
            return '9faa7705-7be2-4757-af64-ba244bd4ecc4';
    }
}

const tenantName = getTenantName();
const scopeSubdomain = getScopeSubdomain();
const clientId = getClientId();
//const loginPolicyId = 'B2C_1A_EFUND_SIGNIN';
const loginPolicyId = 'B2C_1A_SIGNUP_SIGNIN';
// Lands directly on the local-account sign-up form, skipping the combined
// sign-in-first page. Used for "Get Started" entry points; login keeps using
// loginPolicyId above.
const signupPolicyId = 'B2C_1A_SIGNUP';
// Unmodified starter-pack policy used when the combined sign-in policy aborts with error AADB2C90118 (the native Forgot Password link).
const passwordResetPolicyId = 'B2C_1A_PASSWORDRESET';

const authorityBaseUrl = `https://${tenantName}.efundraisingconnections.com/tfp/${tenantName}.efundraisingconnections.com`;

export const b2cPolicies = {
    clientId: clientId,
    authority: `${authorityBaseUrl}/${loginPolicyId}`,
    signupAuthority: `${authorityBaseUrl}/${signupPolicyId}`,
    passwordResetAuthority: `${authorityBaseUrl}/${passwordResetPolicyId}`,
    authorityDomain: `${tenantName}.efundraisingconnections.com`,
    scopes: ["openid", `https://${scopeSubdomain}.efundraisingconnections.com/api/user`],
}